import { createAction } from "@reduxjs/toolkit";
import { createRsaaAction } from "../../components/utilities/ReduxUtils";
import type { AuthenticationSessionResponse } from "../types/Authentication";

export const AUTHENTICATION_GET_SESSION = "AUTHENTICATION_GET_SESSION";
export const CLIENT_SESSION_CLEARED = "CLIENT_SESSION_CLEARED";

export const getAuthenticationSession = createRsaaAction<
    void,
    AuthenticationSessionResponse
>({
    path: "auth/session",
    method: "GET",
    type: AUTHENTICATION_GET_SESSION,
});

export const clearClientSession = createAction(CLIENT_SESSION_CLEARED);
